import React, { useState, useEffect } from 'react';
import { Row, Col, Modal, ModalBody } from 'reactstrap';
import PropTypes from 'prop-types';
import Translate from '../common/Translate';
import CustomCost from './CustomCost';

const ModalCustomCost = (props) => {
  const [modalButtonDisable, setModalButtonDisable] = useState(true);
  const { value, customCostKey, setCustomValues, closeModal, isOpen, questionId } = props;
  const [cost, setCost] = useState('');
  const [label, setLabel] = useState('');
  useEffect(() => {
    if (
      value &&
      value !== undefined &&
      typeof value === 'object' &&
      Object.prototype.hasOwnProperty.call(value, customCostKey)
    ) {
      setCost(value[customCostKey].cost);
      setLabel(value[customCostKey].label);
    }
  }, [isOpen]);

  if (label !== '' && cost !== '' && modalButtonDisable) {
    setModalButtonDisable(false);
  } else if ((label === '' || cost === '') && !modalButtonDisable) {
    setModalButtonDisable(true);
  }

  const saveCustomValues = () => {
    setCustomValues({ [customCostKey]: { label, cost } });
    closeModal();
  };

  return (
    <>
      <Modal isOpen={isOpen} centered>
        <ModalBody>
          <CustomCost questionId={questionId} label={label} cost={cost} setLabel={setLabel} setCost={setCost} />
          <Row className="mt-4 mb-2">
            <Col xs="6" className="text-right" data-cy={questionId}>
              <button type="button" className="btn btn-3" onClick={closeModal} data-cy="model-cancel-btn">
                <Translate code="cancel" />
              </button>
            </Col>
            <Col xs="6" className="text-left" data-cy="model-submit-btn">
              <button
                type="submit"
                className={`btn ${(modalButtonDisable && 'btn-4') || 'btn-1'}`}
                disabled={modalButtonDisable}
                onClick={() => {
                  saveCustomValues();
                }}
              >
                <Translate code="validate" />
              </button>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    </>
  );
};

export default ModalCustomCost;

ModalCustomCost.propTypes = {
  setCustomValues: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  customCostKey: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  isOpen: PropTypes.bool.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  questionId: PropTypes.string.isRequired,
};

ModalCustomCost.defaultProps = {
  value: null,
};
